import React from 'react'

interface IconProps {
  color?: string
  size?: number
}

export const Unpin: React.FC<IconProps> = ({ color = '#fff', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M20.616 16.818a.5.5 0 010 .707l-.708.707a.5.5 0 01-.707 0l-3.18-3.18-.074.073-.707 3.535-1.415 1.415-4.242-4.243-4.596 4.596a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.707l4.596-4.596-4.242-4.243L5.34 8.761l3.536-.707.073-.074-3.183-3.183a.5.5 0 010-.707l.707-.707a.5.5 0 01.708 0l13.435 13.435zm-2.12-4.949a.5.5 0 00.706 0l.987-.987.354.354a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L14.18 2.044a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l.353.353-.987.987a.5.5 0 000 .707l6.364 6.364z"
      fill={color}
    />
  </svg>
)
